import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-organization-unit-card',
  templateUrl: './organization-unit-card.component.html',
  styleUrls: ['./organization-unit-card.component.scss']
})
export class OrganizationUnitCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
